import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@jsverse/transloco';
import { PopoverRef } from 'shared/ui-common';

import { POPOVER_DATA } from '@treetop/shared/model';

import {
  NodePickerEvent,
  ToolbarItemConfig,
  baseToolbarItems,
  mainToolbarItems,
} from '../../infrastructure/operations/node-picker-toolbar/node-picker-toolbar-items.config';

export type AddButtonOptions = {
  element: joint.dia.CellView;
  position1: { name: string };
  position2: { name: string };
  isSubflow: boolean;
  isReplaceElement?: boolean;
  subflowLinkedElement?: boolean;
  previousPosition?: joint.g.PlainPoint;
};

@Component({
  selector: 'tt-add-toolbar-popover',
  standalone: true,
  imports: [MatIconModule, TranslocoModule],
  templateUrl: './add-toolbar-popover.component.html',
  styleUrls: ['./add-toolbar-popover.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddToolbarPopoverComponent implements OnInit {
  private data = inject<{ addButtonParameters: AddButtonOptions }>(POPOVER_DATA);
  private popoverRef = inject<PopoverRef>(PopoverRef);

  protected toolbarItems: ToolbarItemConfig[];

  public ngOnInit(): void {
    const addButtonParameters: AddButtonOptions = this.data.addButtonParameters;

    if (addButtonParameters.isSubflow) {
      this.toolbarItems = baseToolbarItems;
    } else {
      this.toolbarItems = mainToolbarItems;
    }
  }

  protected handleEvent(event: NodePickerEvent): void {
    this.popoverRef.close(event);
  }
}
